import React from 'react';
import { useT } from '../../i18n/LanguageContext';
import './Subscribe.css';

/* Override the default by setting REACT_APP_LAYLO_URL=https://laylo.com/...
   in .env or .env.production if you ever switch handles. */
const LAYLO_URL = process.env.REACT_APP_LAYLO_URL || 'https://laylo.com/ckan';

export default function Subscribe() {
  const { t } = useT();

  const PERKS = [
    { icon: 'fa-solid fa-music',         label: t('subscribe.perk1') },
    { icon: 'fa-solid fa-ticket',        label: t('subscribe.perk2') },
    { icon: 'fa-solid fa-comment-dots',  label: t('subscribe.perk3') },
  ];

  return (
    <section className="sub" aria-labelledby="sub-title">
      <div className="sub__bg" aria-hidden="true" />
      <div className="sub__inner">
        <div className="sub__bell" aria-hidden="true">
          <i className="fa-solid fa-bell" />
        </div>

        <span className="ck-eyebrow">{t('subscribe.eyebrow')}</span>

        <h2 id="sub-title" className="ck-section-title sub__title">
          {t('subscribe.titleA')} <em>{t('subscribe.titleB')}</em>
        </h2>

        <p className="sub__lede">{t('subscribe.lede')}</p>

        <ul className="sub__perks">
          {PERKS.map((p, i) => (
            <li key={i} className="sub__perk">
              <i className={p.icon} />
              <span>{p.label}</span>
            </li>
          ))}
        </ul>

        <a
          href={LAYLO_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="sub__cta"
        >
          <i className="fa-solid fa-bell" />
          <span>{t('subscribe.cta')}</span>
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </a>

        <p className="sub__small">{t('subscribe.fineprint')}</p>
      </div>
    </section>
  );
}
